(function () {
  $(document).ready(function () {
    var carousel = new bootstrap.Carousel(
      document.querySelector('#mainGroupCarousel'), 
      {
        interval: 8000
      }
    );
  });
}());